import Vue from 'vue';

const success = (response, context) => {
  response.data.listings.forEach((listing) => {
    context.listings.push({
      id: listing.id,
      name: listing.name,
      is_airbnbxml: listing.is_airbnbxml,
      choice: listing.choice,
      rental_exists: listing.rental_exists,
      rental_name: listing.rental_name,
    });
  });
};

export default (context) => {
  return Vue.$http.get(`/airbnb/listings?airbnbxml_channel_id=${context.currentAirbnbXmId}`).then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }
  })
    .catch((error) => {
      console.log(error, '[GET] /airbnb/listings error');
    })
    .finally(() => {
      console.log('finally', '[GET] /airbnb/listings');
    });
};



// WEBPACK FOOTER //
// ./src/app/services/airbnb/get-listings.js